import _taggedTemplateLiteral from "/home/vsts/work/1/s/Office.Planner.Website/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n    height: 3.5rem;\n    border-radius: 1rem;\n    ", "\n    ", "\n  "]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n      height: 2.5rem;\n      border-radius: 0.75rem;\n      padding: 0 0.75rem;\n\n      ", "\n    "]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n    background-color: ", ";\n    border-color: ", ";\n    color: ", ";\n\n    &:hover {\n      background-color: ", ";\n      border-color: ", ";\n    }\n  "]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n      background-color: ", ";\n      border-color: ", ";\n      color: ", ";\n\n      &:hover {\n        background-color: ", ";\n        border-color: ", ";\n      }\n    "]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n      background-color: transparent;\n      border-color: transparent;\n      color: ", ";\n\n      &:hover {\n        background-color: ", ";\n        border-color: ", ";\n      }\n    "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n      background-color: ", ";\n      border-color: ", ";\n      color: ", ";\n    "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n      .button-icon {\n        margin-right: 0.5rem;\n        margin-left: -0.25rem;\n      }\n      .button-icon-right {\n        margin-right: -0.25rem;\n        margin-left: 0.5rem;\n      }\n    "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  border: 1px solid transparent;\n  font: inherit;\n  ", ";\n  ", ";\n  display: inline-flex;\n  font-weight: 500;\n  font-size: 0.875rem;\n  user-select: none;\n  text-shadow: none;\n  justify-content: center;\n  align-items: center;\n  text-align: center;\n  white-space: nowrap;\n  transition: background-color 200ms ease 0ms, box-shadow 200ms ease 0ms, border 200ms ease 0ms, color 200ms ease 0ms;\n  position: relative;\n  overflow: hidden;\n  cursor: ", ";\n\n  .button-icon {\n    width: 1.25rem;\n\n    svg {\n      width: 100%;\n      height: auto;\n    }\n  }\n\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled, { css } from 'styled-components';
import { colorShade } from '../utils/colors';
var StyledButton = styled.button(_templateObject(), function (props) {
  return props.size;
}, function (props) {
  return props.colors;
}, function (props) {
  return props.disabled ? 'not-allowed' : 'pointer';
}, function (props) {
  return !props.iconOnly && css(_templateObject2());
});

function Button(_a) {
  var _a$className = _a.className,
      className = _a$className === void 0 ? '' : _a$className,
      _a$appearance = _a.appearance,
      appearance = _a$appearance === void 0 ? 'default' : _a$appearance,
      _a$size = _a.size,
      size = _a$size === void 0 ? 'default' : _a$size,
      _a$disabled = _a.disabled,
      disabled = _a$disabled === void 0 ? false : _a$disabled,
      icon = _a.icon,
      iconRight = _a.iconRight,
      children = _a.children,
      rest = __rest(_a, ["className", "appearance", "size", "disabled", "icon", "iconRight", "children"]);

  return _jsxs(StyledButton, Object.assign({
    disabled: disabled,
    colors: getColors(appearance, disabled),
    className: "button ".concat(children ? '' : 'button-iconOnly', " ").concat(className),
    iconOnly: !children,
    size: getButtonSize(size, !children)
  }, rest, {
    children: [icon && _jsx("span", Object.assign({
      className: "button-icon"
    }, {
      children: icon
    }), void 0), children && children, iconRight && _jsx("span", Object.assign({
      className: "button-icon button-icon-right"
    }, {
      children: iconRight
    }), void 0)]
  }), void 0);
}

function getColors(appearance, disabled) {
  if (disabled) {
    return css(_templateObject3(), function (props) {
      return props.theme.colors.disabled;
    }, function (props) {
      return props.theme.colors.disabled;
    }, function (props) {
      return props.theme.colors.disabledText;
    });
  }

  if (appearance === 'secondary') {
    return css(_templateObject4(), function (props) {
      return props.theme.colors.black;
    }, function (props) {
      return props.theme.colors.accent1;
    }, function (props) {
      return props.theme.colors.accent1;
    });
  }

  if (appearance === 'danger') {
    return css(_templateObject5(), function (props) {
      return props.theme.colors.error;
    }, function (props) {
      return props.theme.colors.error;
    }, function (props) {
      return props.theme.colors.white;
    }, function (props) {
      return colorShade(props.theme.colors.error, -30);
    }, function (props) {
      return colorShade(props.theme.colors.error, -30);
    });
  }

  return css(_templateObject6(), function (props) {
    return props.theme.colors.primary;
  }, function (props) {
    return props.theme.colors.primary;
  }, function (props) {
    return props.theme.colors.white;
  }, function (props) {
    return props.theme.colors.primaryHover;
  }, function (props) {
    return props.theme.colors.primaryHover;
  });
}

function getButtonSize(size, iconOnly) {
  if (size === 'small') {
    return css(_templateObject7(), iconOnly && 'width: 2.5rem;');
  }

  return css(_templateObject8(), !iconOnly && 'padding: 0 1.25rem;', iconOnly && 'width: 3.5rem;');
}

export default Button;